<script setup lang="ts">
withDefaults(defineProps<{ name: string; size?: number; variant?: 'outline' | 'solid' }>(), {
  variant: 'outline',
})
</script>

<template>
  <svg class="app-icon" :data-icon="name" :width="size ?? 24" :height="size ?? 24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <template v-if="variant === 'solid' && name === 'home'">
      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke="none" d="M12 2.65 2.75 10.2v9.05c0 1.1.9 2 2 2h14.5c1.1 0 2-.9 2-2V10.2zM9.4 21.25h5.2v-6.4H9.4z" />
    </template>
    <template v-else-if="variant === 'solid' && name === 'library'">
      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke="none" d="M7 2.5h10a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-13a3 3 0 0 1 3-3m1 4.65v1.7h8v-1.7zm0 4v1.7h8v-1.7zm0 4v1.7h5v-1.7z" />
    </template>
    <template v-else-if="variant === 'solid' && name === 'search'">
      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke="none" d="M10.25 2.5a7.75 7.75 0 1 0 4.74 13.88l4.57 4.57a1.35 1.35 0 0 0 1.91-1.91l-4.57-4.57A7.75 7.75 0 0 0 10.25 2.5m0 3.15a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2" />
    </template>
    <template v-else-if="variant === 'solid' && name === 'calendar'">
      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke="none" d="M5.75 4.25h12.5a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5.75a3 3 0 0 1-3-3v-11a3 3 0 0 1 3-3m-3 3.9v1.7h18.5v-1.7zm3.65-3.9v2.8h1.7v-2.8zm9.5 0v2.8h1.7v-2.8zM7.5 11.8a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4.5 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4.5 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2m-9 4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m4.5 0a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
    </template>
    <template v-else-if="variant === 'solid' && name === 'user'">
      <circle cx="12" cy="7.1" r="4.15" fill="currentColor" stroke="none" />
      <path d="M3.65 21c.55-5.15 3.52-7.72 8.35-7.72S19.8 15.85 20.35 21z" fill="currentColor" stroke="none" />
    </template>
    <template v-else-if="variant === 'solid' && name === 'education'">
      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke="none" d="m12 2.8 10.2 5.35L12 13.5 1.8 8.15zm0 3.05L7.65 8.14 12 10.42l4.35-2.28zM5.15 11.25 12 14.82l6.85-3.57v4.82c-1.66 1.92-3.94 2.88-6.85 2.88s-5.19-.96-6.85-2.88z" />
      <path d="M21.2 8.7v7.1" stroke="currentColor" stroke-width="1.9" />
      <circle cx="21.2" cy="17.65" r="1.25" fill="currentColor" stroke="none" />
    </template>
    <template v-else-if="variant === 'solid' && name === 'service'">
      <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke="none" d="M3 3.5h18v13.1H9.5L3 21.1zm4.4 4.15h9.2v1.8H7.4zm0 4.05h6.25v1.8H7.4z" />
    </template>
    <template v-else-if="variant === 'solid' && name === 'heart'">
      <path fill="currentColor" stroke="none" d="M20.8 5.8a5.5 5.5 0 0 0-7.8 0L12 6.9l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 22l8.8-8.4a5.5 5.5 0 0 0 0-7.8Z" />
    </template>
    <template v-else-if="name === 'home'">
      <path d="m4.25 10.35 7.75-6.2 7.75 6.2v8.35c0 .66-.54 1.2-1.2 1.2H5.45c-.66 0-1.2-.54-1.2-1.2z" />
      <path d="M9.2 19.9v-6.2h5.6v6.2" />
    </template>
    <template v-else-if="name === 'library'">
      <rect x="5" y="3.25" width="14" height="17.5" rx="2.35" />
      <path d="M8.35 8h7.3M8.35 12h7.3M8.35 16h4.6" />
    </template>
    <template v-else-if="name === 'education'">
      <path d="m2.5 9 9.5-5 9.5 5-9.5 5z" />
      <path d="M6 11v5c2.9 2.1 9.1 2.1 12 0v-5M21.5 9v6" />
    </template>
    <template v-else-if="name === 'search'">
      <circle cx="10.75" cy="10.75" r="6.75" /><path d="m15.75 15.75 4.75 4.75" />
    </template>
    <template v-else-if="name === 'calendar'">
      <rect x="3.75" y="4.75" width="16.5" height="15.5" rx="2.4" /><path d="M7.5 2.75v4m9-4v4M3.75 9.25h16.5" />
      <path d="M8 13h.01M12 13h.01M16 13h.01M8 16.75h.01M12 16.75h.01" stroke-width="2.4" />
    </template>
    <template v-else-if="name === 'masonry'">
      <rect x="3" y="3" width="7.5" height="7" rx="1.25" />
      <rect x="13.5" y="3" width="7.5" height="10.5" rx="1.25" />
      <rect x="3" y="13" width="7.5" height="8" rx="1.25" />
      <rect x="13.5" y="16.5" width="7.5" height="4.5" rx="1.25" />
    </template>
    <template v-else-if="name === 'list'">
      <rect x="3" y="4" width="4" height="4" rx=".8" />
      <rect x="3" y="10" width="4" height="4" rx=".8" />
      <rect x="3" y="16" width="4" height="4" rx=".8" />
      <path d="M10 6h11M10 12h11M10 18h11" />
    </template>
    <template v-else-if="name === 'user'">
      <circle cx="12" cy="7.65" r="3.55" /><path d="M5 20.5c.65-4.1 3.2-6.15 7-6.15s6.35 2.05 7 6.15" />
    </template>
    <template v-else-if="name === 'briefcase'">
      <rect x="3" y="7" width="18" height="13" rx="2.25" /><path d="M8.5 7V4.5h7V7M3 12h18M9.25 12v2h5.5v-2" />
    </template>
    <template v-else-if="name === 'bell'">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />
    </template>
    <template v-else-if="name === 'arrow'">
      <path d="M5 12h14m-5-5 5 5-5 5" />
    </template>
    <template v-else-if="name === 'caret-left'">
      <path d="m14.5 6-6 6 6 6" />
    </template>
    <template v-else-if="name === 'caret-right'">
      <path d="m9.5 6 6 6-6 6" />
    </template>
    <template v-else-if="name === 'caret-down'">
      <path d="m6 9 6 6 6-6" />
    </template>
    <template v-else-if="name === 'x'">
      <path d="m7 7 10 10M17 7 7 17" />
    </template>
    <template v-else-if="name === 'bookmark'">
      <path d="M6 3h12v18l-6-4-6 4z" />
    </template>
    <template v-else-if="name === 'play'">
      <circle cx="12" cy="12" r="9" /><path d="m10 8 6 4-6 4z" />
    </template>
    <template v-else-if="name === 'pause'">
      <circle cx="12" cy="12" r="9" /><path d="M10 9v6m4-6v6" />
    </template>
    <template v-else-if="name === 'message'">
      <path d="M4 4h16v12H9l-5 4z" /><path d="M8 9h8m-8 3h5" />
    </template>
    <template v-else-if="name === 'shield'">
      <path d="M12 3 4 6v5c0 5 3.4 8.4 8 10 4.6-1.6 8-5 8-10V6z" /><path d="m9 12 2 2 4-5" />
    </template>
    <template v-else-if="name === 'file'">
      <path d="M6 3h8l4 4v14H6z" /><path d="M14 3v5h5M9 13h6m-6 4h6" />
    </template>
    <template v-else-if="name === 'heart'">
      <path d="M20.8 5.8a5.5 5.5 0 0 0-7.8 0L12 6.9l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 22l8.8-8.4a5.5 5.5 0 0 0 0-7.8Z" />
    </template>
    <template v-else-if="name === 'clock'">
      <circle cx="12" cy="12" r="9" /><path d="M12 7v6l4 2" />
    </template>
    <template v-else-if="name === 'sparkles'">
      <path d="m12 3 1.4 4.1L18 9l-4.6 1.9L12 15l-1.4-4.1L6 9l4.6-1.9zM5 15l.8 2.2L8 18l-2.2.8L5 21l-.8-2.2L2 18l2.2-.8zM19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8z" />
    </template>
    <template v-else-if="name === 'check'">
      <circle cx="12" cy="12" r="9" /><path d="m8 12 3 3 5-6" />
    </template>
    <template v-else-if="name === 'form'">
      <path d="M6 3h12v18H6z" /><path d="M9 8h6M9 12h6M9 16h3" /><path d="m14 16 1.5 1.5L19 14" />
    </template>
    <template v-else-if="name === 'service'">
      <path d="M4 5h16v11H9l-5 4z" /><path d="M8 9h8M8 12h5" />
    </template>
    <template v-else-if="name === 'lock'">
      <rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
    </template>
    <template v-else-if="name === 'warning'">
      <path d="M12 3 2.5 20h19z" /><path d="M12 9v5m0 3h.01" />
    </template>
    <template v-else-if="name === 'download'">
      <path d="M12 3v12m-4-4 4 4 4-4M5 21h14" />
    </template>
    <template v-else-if="name === 'share'">
      <circle cx="18" cy="5" r="2.25" /><circle cx="6" cy="12" r="2.25" /><circle cx="18" cy="19" r="2.25" /><path d="m8 10.9 7.9-4.6M8 13.1l7.9 4.6" />
    </template>
    <template v-else>
      <circle cx="12" cy="12" r="9" /><path d="M12 8v4m0 4h.01" />
    </template>
  </svg>
</template>
